import { createStore } from "redux";

const initialState = {
  sidebarShow: "responsive",
  sidebarHide: "hide",
  notification: { isShow: false, data: "" },
  modal: { visible: false, modelType: "", data: {} },
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    case "NOTIFICATION_DESTROY":
      return { ...state, notification: { isShow: false } };
    case "NOTIFICATION_SUCCESS":
      return {
        ...state,
        notification: { ...rest, type: "success", isShow: true },
      };
    case "NOTIFICATION_ERROR":
      return {
        ...state,
        notification: { ...rest, type: "error", isShow: true },
      };
    case "CLOSE_MODAL":
      return {
        ...state,
        modal: { visible: false },
      };
    case "OPEN_MODAL":
      return {
        ...state,
        modal: { visible: true, ...rest },
      };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
